import { render } from "./UnitsArea.vue?vue&type=template&id=47764362&scoped=true"
import script from "./UnitsArea.vue?vue&type=script&lang=js"
export * from "./UnitsArea.vue?vue&type=script&lang=js"

import "./UnitsArea.vue?vue&type=style&index=0&id=47764362&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47764362"]])

export default __exports__